"use client";

import { PropsWithChildren, useEffect } from "react";

import { NextUIProvider } from "@nextui-org/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "react-hot-toast";

// import DEFAULT_SEO_CONFIG from "@/config/next-seo.config";
// import { DefaultSeo } from "next-seo";
import { initFeatureFlags } from "@/lib/feature-flags-init";
import { QueryClientProviders } from "@/providers/queryClientProvider";
import { setupChunkRetry } from "@/utils/chunk-retry";

export function RootProviders({ children }: PropsWithChildren) {
  // Setup chunk retry logic on client side
  useEffect(() => {
    setupChunkRetry();
    initFeatureFlags();
  }, []);

  return (
    <QueryClientProviders>
      <NextUIProvider>
        <GoogleOAuthProvider
          clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || ""}
        >
          <Toaster
            position="bottom-right"
            containerStyle={{ zIndex: "var(--z-index-toaster)" }}
            toastOptions={{
              className: "toastStyle",
              duration: 5000,
              style: {
                background: "#363636",
                color: "#fff",
                zIndex: "var(--z-index-toaster)",
              },
            }}
          />
          {/* Default SEO configuration */}
          {/* <DefaultSeo {...DEFAULT_SEO_CONFIG} /> */}
          {children}
        </GoogleOAuthProvider>
      </NextUIProvider>
    </QueryClientProviders>
  );
}
